import React from 'react';
import './ScaleUpCall.css';

const ScaleUpCall = () => {
  const [benefitsOpen, setBenefitsOpen] = React.useState(true);

  const handleTeamCallClick = () => {
    window.open('https://calendly.com/salesgod/scaleup-team-call', '_blank');
  };

  const handleJulianCallClick = () => {
    window.open('https://calendly.com/salesgod/scaleup-session-mit-julian', '_blank');
  };

  const toggleBenefits = () => {
    setBenefitsOpen(!benefitsOpen);
  };

  return (
    <div id="strategy-session" className="scaleup-call-wrapper">
      <div className="scaleup-call-container">
        {/* Section Header */}
        <div className="scaleup-call-header">
          <h2 className="scaleup-call-main-title">
            <span className="scaleup-title-monty">Ready to</span>{' '}
            <span className="scaleup-title-montas">SCALE?</span>
          </h2>
          <div className="scaleup-call-main-title-divider"></div>
          <p className="scaleup-call-subtitle">
            In the ScaleUp Call, we'll analyze together<br />
            what's currently holding your brand back –
            and which clear steps will make your brand scalable in the next 90 days.
          </p>
        </div>

        {/* Pricing Cards Container */}
        <div className="scaleup-cards-grid">
          {/* Animated Orbs Background */}
          <div className="scaleup-orbs-container">
            <div className="scaleup-orb scaleup-orb-1"></div>
            <div className="scaleup-orb scaleup-orb-2"></div>
            <div className="scaleup-orb scaleup-orb-3"></div>
            <div className="scaleup-orb scaleup-orb-4"></div>
          </div>

          {/* Free Team Call */}
          <div className="scaleup-card scaleup-card-free">
            <div className="scaleup-card-header">
              <div className="scaleup-card-badge scaleup-badge-free">Free</div>
              <h3 className="scaleup-card-title">ScaleUp Call with Team</h3>
              <p className="scaleup-card-description">
                The perfect way to get to know us. We'll analyze together where you currently stand and which initial steps make sense for your growth.
              </p>
              <p className="scaleup-card-duration">45 Minute Session</p>
              <div className="scaleup-card-price">
                <span className="scaleup-price-amount">Free</span>
              </div>
            </div>

            <div className="scaleup-card-features">
              <ul className="scaleup-features-list">
                <li className="scaleup-feature-item scaleup-feature-included">
                  <i className="scaleup-feature-icon fas fa-check"></i>
                  <span><strong>Casual Introduction with the Team</strong></span>
                </li>
                <li className="scaleup-feature-item scaleup-feature-included">
                  <i className="scaleup-feature-icon fas fa-check"></i>
                  <span>Initial <strong>Business Assessment</strong></span>
                </li>
                <li className="scaleup-feature-item scaleup-feature-included">
                  <i className="scaleup-feature-icon fas fa-check"></i>
                  <span>Identification of <strong>Biggest Revenue Levers</strong></span>
                </li>
                <li className="scaleup-feature-item scaleup-feature-excluded">
                  <i className="scaleup-feature-icon fas fa-times"></i>
                  <span>Detailed market analysis of your industry</span>
                </li>
                <li className="scaleup-feature-item scaleup-feature-excluded">
                  <i className="scaleup-feature-icon fas fa-times"></i>
                  <span>AI-powered business case analysis</span>
                </li>
                <li className="scaleup-feature-item scaleup-feature-excluded">
                  <i className="scaleup-feature-icon fas fa-times"></i>
                  <span>14-page business analysis report</span>
                </li>
              </ul>
            </div>

            <button 
              className="scaleup-card-button scaleup-button-free"
              onClick={handleTeamCallClick}
            >
              Book Free Call
            </button>
          </div>

          {/* Premium Julian Call */}
          <div className="scaleup-card scaleup-card-premium">
            <div className="scaleup-card-header">
              <div className="scaleup-card-badge scaleup-badge-premium">VIP Service</div>
              <h3 className="scaleup-card-title"><span className="scaleup-silver-text">ScaleUp</span> Session with Julian</h3>
              <p className="scaleup-card-description">
                Your exclusive deep dive with Julian. Get a complete analysis of your business, concrete strategies, and a tailored roadmap for explosive growth.
              </p>
              <p className="scaleup-card-duration">60 Minute Personal Session with Julian</p>
              <div className="scaleup-card-price">
                <span className="scaleup-price-amount scaleup-price-sold-out">$649</span>
                <p className="scaleup-sold-out-text">Fully Booked until End of 2025</p>
              </div>
            </div>

            <div className="scaleup-card-features">
              <ul className="scaleup-features-list">
                <li className="scaleup-feature-item scaleup-feature-included">
                  <i className="scaleup-feature-icon fas fa-check"></i>
                  <span><strong>1:1 Strategic Session</strong> with Julian Propst</span>
                </li>
                <li className="scaleup-feature-item scaleup-feature-included">
                  <i className="scaleup-feature-icon fas fa-check"></i>
                  <span><strong>Status Quo</strong> & Potential Analysis</span>
                </li>
                <li className="scaleup-feature-item scaleup-feature-included">
                  <i className="scaleup-feature-icon fas fa-check"></i>
                  <span><strong>Market Analysis</strong> specific to your industry</span>
                </li>
                <li className="scaleup-feature-item scaleup-feature-included">
                  <i className="scaleup-feature-icon fas fa-check"></i>
                  <span><strong>AI-powered</strong> Business Case Analysis</span>
                </li>
                <li className="scaleup-feature-item scaleup-feature-included">
                  <i className="scaleup-feature-icon fas fa-check"></i>
                  <span>Identification of <strong>Biggest Revenue Levers</strong></span>
                </li>
                <li className="scaleup-feature-item scaleup-feature-included scaleup-feature-highlight">
                  <div className="scaleup-bonus-badge">Bonus</div>
                  <div className="scaleup-highlight-content">
                    <span className="scaleup-feature-icon">
                      <img src="/img/gift.svg" alt="Document" />
                    </span>
                    <div className="scaleup-highlight-text">
                      <span className="scaleup-highlight-title">Personal ScaleUp Strategy Plan</span>
                      <span className="scaleup-highlight-subtitle">as professional PDF</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <button 
              className="scaleup-card-button scaleup-button-premium scaleup-button-sold-out"
              disabled
            >
              Fully Booked
            </button>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="scaleup-benefits-section">
          <div className="scaleup-benefits-header" onClick={toggleBenefits}>
            <h3 className="scaleup-benefits-title">
              What will change after your ScaleUp Call <span className="scaleup-benefits-highlight">transforms your business</span>
            </h3>
            <button className="scaleup-benefits-toggle" aria-label={benefitsOpen ? 'Close benefits' : 'Open benefits'}>
              <svg 
                className={`scaleup-toggle-icon ${benefitsOpen ? 'scaleup-toggle-open' : ''}`}
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M19 9L12 16L5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
          
          <div className={`scaleup-benefits-grid ${benefitsOpen ? 'scaleup-benefits-visible' : ''}`}>
            <div className="scaleup-benefit-card">
              <div className="scaleup-benefit-icon-wrapper">
                <svg className="scaleup-benefit-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
                </svg>
              </div>
              <h4 className="scaleup-benefit-title">Crystal-Clear Growth Strategy</h4>
              <p className="scaleup-benefit-text">
                You'll leave with a customized scaling plan tailored to you –
                no more guesswork, but a clear roadmap for the next 90 days.
              </p>
            </div>

            <div className="scaleup-benefit-card">
              <div className="scaleup-benefit-icon-wrapper">
                <svg className="scaleup-benefit-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" fill="currentColor"/>
                </svg>
              </div>
              <h4 className="scaleup-benefit-title">Precise Focus Instead of Constant Firefighting</h4>
              <p className="scaleup-benefit-text">
                You'll recognize which actions actually generate revenue –
                and which you can eliminate immediately to free up time and energy.
              </p>
            </div>

            <div className="scaleup-benefit-card">
              <div className="scaleup-benefit-icon-wrapper">
                <svg className="scaleup-benefit-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2V22M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="scaleup-benefit-title">Noticeably More Inquiries & Revenue</h4>
              <p className="scaleup-benefit-text">
                You'll understand where your sales and marketing are currently blocking –
                and get concrete levers to immediately fill your sales pipeline.
              </p>
            </div>

            <div className="scaleup-benefit-card">
              <div className="scaleup-benefit-icon-wrapper">
                <svg className="scaleup-benefit-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" fill="currentColor"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="scaleup-benefit-title">Predictable Growth Instead of Random Wins</h4>
              <p className="scaleup-benefit-text">
                You'll learn how to build systems that make leads, customers, and cash flow reproducible –
                so your business no longer depends on luck or "good weeks."
              </p>
            </div>

            <div className="scaleup-benefit-card">
              <div className="scaleup-benefit-icon-wrapper">
                <svg className="scaleup-benefit-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="12" r="3" fill="currentColor"/>
                </svg>
              </div>
              <h4 className="scaleup-benefit-title">Visible Brand with Trust Effect</h4>
              <p className="scaleup-benefit-text">
                You'll discover what's making your brand appear unclear right now –
                and how to sharpen your positioning, branding, and communication
                so customers immediately perceive you as premium.
              </p>
            </div>

            <div className="scaleup-benefit-card">
              <div className="scaleup-benefit-icon-wrapper">
                <svg className="scaleup-benefit-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M12 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h4 className="scaleup-benefit-title">Access to My Network</h4>
              <p className="scaleup-benefit-text">
                If there's someone in my network
                who could provide real value to your project,
                I'll connect you.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScaleUpCall;

